/* Liquor Library v3: site-wide behaviour on Shopify's own cart and search APIs. No other services. */
(() => {
  const LL = window.LL || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (c) => '$' + (c / 100).toFixed(2);
  // fills [over] [amt] [left] [earned] for the "spend $500, get $10 back" reward from a cart total in cents
  LL.rw$ = (tpl, cents) => { const R = LL.rw, n = Math.floor(cents / R.over), d = (c) => money(c).replace('.00', ''); return tpl.replace('[over]', d(R.over)).replace('[amt]', d(R.amt)).replace('[left]', d(R.over - (cents % R.over))).replace('[earned]', n === 1 ? `a ${d(R.amt)} gift card` : `${d(n * R.amt)} in gift cards`); };
  const store = {
    get: (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } },
    set: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
  };
  const json = (url, body) => fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j; });
  window.LLu = { $, $$, money, store, json };

  /* ---------- reveals ([data-rv], [data-drop]) ---------- */
  const rvs = $$('[data-rv],[data-drop]');
  if (!document.documentElement.classList.contains('rv-on')) rvs.forEach((e) => e.classList.add('in'));
  else { const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -12% 0px' }); rvs.forEach((e) => io.observe(e)); }

  /* ---------- smooth open/close: LLu.swing(box, set, open) glides box's height while set(open) flips its state ---------- */
  const swing = (box, set, open) => {
    const from = box.offsetHeight;
    box.getAnimations().forEach((a) => a.cancel());
    set(open); const to = box.offsetHeight;
    if (from === to || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    set(true);
    const a = box.animate({ height: [from + 'px', to + 'px'], boxSizing: ['border-box', 'border-box'], overflow: ['hidden', 'hidden'] }, { duration: 360, easing: 'cubic-bezier(.22,.61,.36,1)' });
    a.onfinish = () => set(open);
  };
  window.LLu.swing = swing;
  // Sort menus (.sx-sortd) close the way they open: the list fades and lifts out, then the <details> shuts
  const shut = (d) => {
    const l = d.querySelector('.sx-sortl');
    if (!d.open || d.dataset.shutting) return;
    if (!l || matchMedia('(prefers-reduced-motion: reduce)').matches) { d.open = false; return; }
    d.dataset.shutting = '1';
    l.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-6px) scale(.97)' }], { duration: 170, easing: 'cubic-bezier(.4,0,1,1)' })
      .onfinish = () => { delete d.dataset.shutting; d.open = false; };
  };
  window.LLu.shut = shut;
  // every <details> accordion on the site; the Sort menus (.sx-sortd) drop down instead, and .pk-more animates itself in CSS
  document.addEventListener('click', (e) => {
    const s = e.target.closest('summary'), d = s?.parentElement;
    if (e.defaultPrevented || d?.tagName !== 'DETAILS' || d.querySelector(':scope>summary') !== s || d.matches('.pk-more details')) return;
    if (d.matches('.sx-sortd')) { if (d.open) { e.preventDefault(); shut(d); } return; }
    e.preventDefault();
    swing(d, (v) => { d.open = v; }, !d.open);
  });

  /* ---------- ticker ---------- */
  const tick = $('#ubTick');
  if (tick) {
    const msgs = $$('.ub-msg', tick); let i = 0, paused = false;
    ['mouseenter', 'focusin'].forEach((ev) => tick.addEventListener(ev, () => (paused = true)));
    ['mouseleave', 'focusout'].forEach((ev) => tick.addEventListener(ev, () => (paused = false)));
    if (msgs.length > 1) setInterval(() => {
      if (paused || document.hidden) return;
      const cur = msgs[i]; i = (i + 1) % msgs.length;
      cur.classList.remove('on'); cur.classList.add('out'); setTimeout(() => cur.classList.remove('out'), 650);
      msgs[i].classList.add('on');
    }, 4000);
  }

  /* ---------- mobile menu ---------- */
  const hd = $('#hd2'), mn = $('#mn'), mnBtn = $('#mnOpen');
  mnBtn?.addEventListener('click', () => {
    const open = mn.hidden;
    mn.style.setProperty('--mn-top', ($('.hd4-main', hd) || hd).getBoundingClientRect().bottom + 'px'); // phones: #hd2 is display:contents
    mn.hidden = !open; hd.classList.toggle('mn-open', open); mnBtn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  });
  // phone menu panel: the close button or a tap on the dimmed page closes it
  mn?.addEventListener('click', (e) => { if (e.target === mn || e.target.closest('[data-mn-close]')) mnBtn.click(); });

  /* ---------- mega menu, design B "Hover to browse" (20 Oct 2026, mockups/mega-menu-options.html?v=b) ---------- */
  const mega = $('#mega');
  if (mega && document.documentElement.classList.contains('nav-5')) {
    const links = $$('.hd4-cats-in .cats-links a'); let tOpen, tClose, cur = -1;
    mega.hidden = false; // open/closed is the .open class from here, so it can fade
    const show = (i) => {
      const p = $(`.mega-p[data-mega="${i}"]`, mega);
      if (p) $$('.mega-p', mega).forEach((x) => (x.hidden = x !== p));
      mega.classList.toggle('open', !!p); cur = p ? i : -1;
      links.forEach((a, k) => a.classList.toggle('on', k === cur));
    };
    links.forEach((a, i) => {
      // short hover delay so passing over the bar doesn't flicker; switching between open panels is quicker
      a.addEventListener('mouseenter', () => { clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(() => show(i), cur < 0 ? 140 : 60); });
      a.addEventListener('mouseleave', () => clearTimeout(tOpen));
      a.addEventListener('focus', () => show(i));
    });
    $('#hd2').addEventListener('mouseleave', () => { clearTimeout(tOpen); tClose = setTimeout(() => show(-1), 220); });
    $('#hd2').addEventListener('mouseenter', () => clearTimeout(tClose));
    addEventListener('keydown', (e) => { if (e.key === 'Escape') show(-1); });
    // a rail row swaps the pane; keyword rows (no Shopify sub-collection) fill once from predictive search
    $$('.mg-row', mega).forEach((r) => r.addEventListener('mouseenter', () => {
      const p = r.closest('.mega-p');
      $$('.mg-row', p).forEach((x) => x.classList.toggle('on', x === r));
      $$('.mg-pane', p).forEach((x) => (x.hidden = x.dataset.row !== r.dataset.row));
      const box = $(`.mg-pane[data-row="${r.dataset.row}"] [data-q]`, p);
      if (!box || box.dataset.done) return;
      box.dataset.done = 1;
      fetch(`/search/suggest.json?q=${encodeURIComponent(box.dataset.q)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide`)
        .then((x) => x.json()).then((j) => window.LLcards(j.resources.results.products.map((x) => x.handle), 'mini'))
        .then((h) => { box.innerHTML = h; }).catch(() => { delete box.dataset.done; });
    }));
  }

  /* ---------- favourites + recently viewed (product handles in localStorage) ---------- */
  const favs = () => store.get('ll_favs', []).filter((x) => typeof x === 'string');
  const favBadge = () => { const n = favs().length, b = $('#favN'); if (b) { b.textContent = n; b.hidden = !n; } };
  window.LLfav = {
    list: favs, has: (h) => favs().includes(h),
    toggle: (h) => { const f = favs(), k = f.indexOf(h); k < 0 ? f.push(h) : f.splice(k, 1); store.set('ll_favs', f); favBadge(); return k < 0; },
    // the heart on every product card (snippets/ll-card.liquid); call paint() again after cards are swapped in
    paint: () => { const f = favs(); document.querySelectorAll('[data-fav]').forEach((b) => b.setAttribute('aria-pressed', f.includes(b.dataset.fav))); },
  };
  favBadge(); window.LLfav.paint();
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-fav]'); if (b) b.setAttribute('aria-pressed', window.LLfav.toggle(b.dataset.fav)); });
  // a product's card or mini card, rendered by Shopify (templates/product.card.liquid / product.mini.liquid)
  window.LLcards = (handles, view = 'card') => Promise.all(handles.map((h) => fetch(`/products/${encodeURIComponent(h)}?view=${view}`).then((r) => (r.ok ? r.text() : '')).catch(() => ''))).then((a) => a.join(''));

  /* ---------- search, design D (20 Oct 2026): field over the header bar, panel under it ---------- */
  const sv = $('#sv'), svQ = $('#svQ');
  if (sv) {
    const homeSide = $('#svHome'), sug = $('#svSug'), rows = $('#svRows'), head = $('#svH'), all = $('#svAll'), clr = $('#svClr');
    const popular = rows.innerHTML;
    let seq = 0, idx = -1, t;
    const esc = (x) => x.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    const hi = (n) => { const r = $$('.sv-row', rows); r.forEach((x, i) => x.classList.toggle('on', i === n)); idx = n; r[n]?.scrollIntoView({ block: 'nearest' }); };
    const mark = (term) => {
      const w = term.split(/\s+/).filter(Boolean).map((x) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      const re = new RegExp('(' + w.join('|') + ')', 'ig');
      $$('.sv-row b', rows).forEach((b) => { b.innerHTML = esc(b.textContent).replace(re, '<mark>$1</mark>'); });
    };
    const search = async () => {
      const term = svQ.value.trim(), my = ++seq;
      clr.hidden = !svQ.value;
      if (term.length < 2) { homeSide.hidden = false; sug.hidden = true; head.textContent = head.dataset.home; rows.innerHTML = popular; all.hidden = true; idx = -1; return; }
      const r = await fetch(`${LL.routes.predictive}?q=${encodeURIComponent(term)}&resources[type]=product,query,collection&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=ll-predictive`).then((x) => x.text()).catch(() => '');
      if (my !== seq) return;
      const box = document.createElement('div'); box.innerHTML = r;
      const found = $$('.sv-row', box), s = $('[data-sug]', box), c = $('[data-col]', box);
      const side = (s && s.children.length ? `<p class="sv-k">${sug.dataset.s}</p>${s.innerHTML}` : '') + (c && c.children.length ? `<p class="sv-k">${sug.dataset.c}</p><div class="sv-lst">${c.innerHTML}</div>` : '');
      sug.innerHTML = side || `<p class="sv-tip">${sug.dataset.none}</p>`;
      homeSide.hidden = true; sug.hidden = false;
      head.textContent = found.length ? `Top matches for “${term}”` : `Nothing on the shelf for “${term}”. Try a grape, a region or a style.`;
      rows.replaceChildren(...found); mark(term); idx = -1;
      all.href = `${LL.routes.search}?type=product&q=${encodeURIComponent(term)}`; all.hidden = !found.length;
    };
    const place = () => {
      const b = $('#sovOpen'), r = b && b.offsetWidth ? b.getBoundingClientRect() : null;
      sv.classList.toggle('sv-m', !r || innerWidth <= 900);
      if (r) [['--sx', r.left], ['--sy', r.top], ['--sw', r.width], ['--sh', r.height]].forEach(([k, v]) => sv.style.setProperty(k, v + 'px'));
    };
    const open = () => { if (sv.classList.contains('in')) return; place(); sv.hidden = false; document.body.style.overflow = 'hidden'; requestAnimationFrame(() => sv.classList.add('in')); svQ.focus(); };
    const close = () => { sv.classList.remove('in'); document.body.style.overflow = ''; setTimeout(() => { if (!sv.classList.contains('in')) sv.hidden = true; }, 320); };
    ['#sovOpen', '#sovOpenM'].forEach((s) => $(s)?.addEventListener('click', open));
    $$('[data-sv-close]', sv).forEach((b) => b.addEventListener('click', close));
    clr.addEventListener('click', () => { svQ.value = ''; search(); svQ.focus(); });
    svQ.addEventListener('input', () => { clearTimeout(t); t = setTimeout(search, 180); });
    svQ.addEventListener('keydown', (e) => {
      const r = $$('.sv-row', rows);
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && r.length) { e.preventDefault(); hi(idx < 0 && e.key === 'ArrowUp' ? r.length - 1 : (idx + (e.key === 'ArrowDown' ? 1 : -1) + r.length) % r.length); }
      else if (e.key === 'Enter' && r[idx]) { e.preventDefault(); location.href = r[idx].href; }
    });
    sv.addEventListener('click', (e) => { const a = e.target.closest('[data-q]'); if (a) { e.preventDefault(); svQ.value = a.dataset.q; search(); svQ.focus(); } });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !sv.hidden) close(); });
    addEventListener('resize', () => { if (!sv.hidden) place(); });
  }

  /* ---------- cart drawer (Shopify AJAX cart): design D "calm list", frozen navy header (20 Oct 2026) ---------- */
  const cd = $('#cd'), scrim = $('#cdScrim');
  let cart = null;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const caseN = (it) => (it.product_type === 'Case' ? parseInt(it.variant_title, 10) || 0 : 0);
  const d0 = (c) => money(c).replace('.00', '');
  const svg = (p, w = 2) => `<svg viewBox="0 0 24 24" aria-hidden="true" style="stroke-width:${w}">${p}</svg>`;
  const IC = { minus: svg('<path d="M5 12h14"/>'), plus: svg('<path d="M12 5v14M5 12h14"/>'), arrow: svg('<path d="M5 12h14M13 6l6 6-6 6"/>', 2.2), down: svg('<path d="M6 9l6 6 6-6"/>', 2.2), check: svg('<path d="M5 12l5 5 9-10"/>', 3) };
  // per product: price sticker + its 6/12 case, from templates/product.llcart.liquid, fetched once per page
  const meta = {}, metaP = {};
  const loadMeta = (items) => Promise.all([...new Set(items.map((it) => it.handle))].filter((h) => !metaP[h])
    .map((h) => (metaP[h] = fetch(`/products/${h}?view=llcart`).then((r) => r.json()).then((m) => (meta[h] = m)).catch(() => (meta[h] = { k: '', cases: [] })))));
  const props = (it) => Object.entries(it.properties || {}).filter(([k, v]) => v && !k.startsWith('_') && k !== 'For box');
  const openDt = new Set();
  const isBox = (it) => it.product_type === 'Gift basket';

  // the one-line bundle nudge: a case line offers the next size up, 3 to 5 single bottles offer the 6 (and 9 to 11 the 12)
  function nudge(it, cn) {
    const m = meta[it.handle]; if (!m || !m.cases?.length || props(it).length) return '';
    const cs = m.cases.filter((c) => c.a !== false).sort((a, b) => a.n - b.n), w = m.w || 'bottle';
    if (cn) {
      const up = cs.find((c) => c.n > cn && c.p / c.n < it.final_price / cn);
      return up ? `<button type="button" class="cx-nd" data-up="${up.v}" data-left="${it.quantity - 1}">Make it a ${up.n} for ${money(Math.round(up.p / up.n))} a ${w}${IC.arrow}</button>` : '';
    }
    const c = cs.find((x) => x.n > it.quantity && x.n - it.quantity <= 3 && x.p / x.n < it.final_price);
    return c ? `<button type="button" class="cx-nd" data-up="${c.v}" data-left="0">Add ${c.n - it.quantity} more for ${money(Math.round(c.p / c.n))} a ${w}${IC.arrow}</button>` : '';
  }
  function details(it, extras) {
    const li = props(it).filter(([k]) => k !== 'To' && k !== 'Deliver on').map(([k, v]) => `<li><span><small>${esc(k)}</small>${k === 'Gift note' ? `“${esc(v)}”` : esc(v)}</span></li>`);
    extras.forEach((x) => {
      const ph = (x.properties || {}).Photo;
      li.push(/^https:\/\//.test(ph || '')
        ? `<li class="th pol"><img src="${esc(ph)}" alt=""><span><small>Photo</small>${esc(x.product_title)}</span><em>${money(x.final_line_price)}</em></li>`
        : `<li class="th"><img src="${esc(x.image || '')}&width=100" alt=""><span><small>Added</small>${esc(x.product_title)}${x.quantity > 1 ? ` × ${x.quantity}` : ''}</span><em>${money(x.final_line_price)}</em></li>`);
    });
    return li.length ? `<div class="cx-dt"><div><ul>${li.join('')}</ul></div></div>` : '';
  }
  function row(it, i, extras) {
    const cn = caseN(it), m = meta[it.handle] || {}, box = isBox(it), pr = Object.fromEntries(props(it));
    const title = cn ? it.product_title.replace(/\s+Case$/i, '') : it.product_title;
    const sec = cn ? `Case of ${cn} · ${money(Math.round(it.final_price / cn))} a ${m.w || 'bottle'}`
      : it.gift_card ? (pr['Recipient name'] ? `Emailed to ${pr['Recipient name']}` : 'Emailed in minutes')
      : box ? [pr.To && `For ${pr.To}`, pr['Deliver on'] && `arrives ${pr['Deliver on']}`].filter(Boolean).join(' · ') || 'Gift box'
      : [m.t || it.product_type, it.variant_title && !/default/i.test(it.variant_title) ? it.variant_title : '', it.selling_plan_allocation ? `Subscription, ${it.selling_plan_allocation.selling_plan.name.toLowerCase()}` : ''].filter(Boolean).join(' · ');
    const fixed = box || props(it).length;
    const dt = box ? details(it, extras) : '';
    const total = it.final_line_price + extras.reduce((s, x) => s + x.final_line_price, 0);
    const was = it.original_line_price + extras.reduce((s, x) => s + x.original_line_price, 0);
    const thumb = it.gift_card ? `<span class="cx-gc">${d0(it.final_price)}</span>` : (m.i || it.image) ? `<img src="${esc(m.i || `${it.image}&width=240`)}" alt="">` : '';
    const open = openDt.has(it.key);
    return `<li class="cx-r${open ? ' open-dt' : ''}" data-k="${esc(it.key)}" style="--i:${i}"><div><div class="cx-row">
      <a class="cx-img${box ? ' cover' : ''}" href="${esc(it.url)}" tabindex="-1">${thumb}</a>
      <div>${m.k ? `<div class="cx-tag"><i class="lp lp-${m.k}">${esc(m.l)}</i></div>` : ''}<a class="cx-nm" href="${esc(it.url)}">${esc(title)}</a>${sec ? `<div class="cx-sec">${esc(sec)}</div>` : ''}
        ${nudge(it, cn)}${dt ? `<button type="button" class="cx-dt-t" data-dt aria-expanded="${open}">${open ? 'Hide details' : 'See details'}${IC.down}</button>` : ''}
        <div class="cx-act">${fixed ? '' : `<span class="cx-st"><button type="button" data-q="-1" aria-label="One less">${IC.minus}</button><b>${it.quantity}</b><button type="button" data-q="1" aria-label="One more">${IC.plus}</button></span>`}<button type="button" class="cx-rm" data-rm>Remove</button></div></div>
      <div class="cx-pr">${money(total)}${was > total ? `<s>${money(was)}</s>` : ''}</div>${dt}
    </div></div></li>`;
  }
  // reward header: "$X spent of $500", one yellow bar, live; small celebration when it is earned
  let shownSpent = 0, lastEarned = null;
  function countTo(el, to) {
    const from = shownSpent, t0 = performance.now(); shownSpent = to;
    const step = (t) => { const k = Math.min(1, (t - t0) / 500); el.textContent = money(Math.round(from + (to - from) * (1 - (1 - k) ** 3))); if (k < 1 && shownSpent === to) requestAnimationFrame(step); };
    requestAnimationFrame(step); setTimeout(() => { if (shownSpent === to) el.textContent = money(to); }, 600); // lands even if rAF is paused
  }
  function reward(sub, count, giftOnly) {
    const R = LL.rw, earned = Math.floor(sub / R.over), rw = $('#cdRw'), bar = $('#cdBar');
    rw.hidden = !count;
    rw.classList.toggle('won', earned > 0);
    $('.cx-rw-top', rw).hidden = giftOnly; bar.parentElement.hidden = giftOnly;
    $('#cdFreeTxt').innerHTML = giftOnly ? LL.t.cdGift : LL.rw$(earned ? LL.t.cdDone : LL.t.cdLeft, sub);
    $('#cdOf').textContent = earned ? 'spent' : `spent of ${d0(R.over)}`;
    $('#cdChip').innerHTML = earned ? `${IC.check}${d0(R.amt * earned)} back earned` : `${d0(R.amt)} back`;
    bar.style.transform = `scaleX(${earned ? 1 : sub / R.over})`;
    countTo($('#cdSpent'), sub);
    if (lastEarned === 0 && earned > 0) { rw.classList.remove('pop'); void rw.offsetWidth; rw.classList.add('pop'); }
    lastEarned = earned;
  }
  const giftOnly = () => cart.item_count > 0 && cart.items.every((it) => it.gift_card); // gift cards are emailed: no delivery to qualify for
  function render() {
    if (!cart) return;
    const sub = cart.total_price, count = cart.item_count, R = LL.rw, earned = Math.floor(sub / R.over), rem = sub % R.over;
    const n = $('#cartN'); if (n) { n.textContent = count; n.hidden = !count; }
    const tot = $('#cartTot'); if (tot) tot.textContent = count ? money(sub) : 'Cart';
    const ub = $('#ubFreeTxt'), ubBar = $('#ubBar');
    if (ub) ub.innerHTML = LL.rw$(!count ? LL.t.barIdle : earned ? LL.t.barDone : LL.t.barLeft, sub);
    if (ubBar) ubBar.style.transform = `scaleX(${rem / R.over})`;
    if (!cd) return;
    $('#cdN').textContent = count ? `${count} item${count === 1 ? '' : 's'}` : '';
    $('#cdSub').textContent = money(sub);
    $('#cdSave').hidden = !cart.total_discount; $('#cdSaveV').textContent = money(cart.total_discount);
    $('#cdFt').hidden = !count;
    reward(sub, count, giftOnly());
    // add-ons ("For box") fold into their gift box's See details
    const boxes = cart.items.filter(isBox), extras = new Map(boxes.map((b) => [b.key, []])), shown = [];
    cart.items.forEach((it) => {
      const fb = (it.properties || {})['For box'], b = fb && !isBox(it) && boxes.find((x) => x.product_title === fb);
      if (b) extras.get(b.key).push(it); else shown.push(it);
    });
    $('#cdList').innerHTML = shown.length ? shown.map((it, i) => row(it, i, extras.get(it.key) || [])).join('')
      : `<li class="cx-em"><h3>${esc(LL.t.cdEmpty)}</h3><p>Everyday low prices on every bottle.</p><a href="${LL.routes.specials}">${esc(LL.t.cdEmptyLink)}</a></li>`;
  }
  const refresh = () => json(`${LL.routes.cart}.js`).then(async (c) => { cart = c; render(); const had = Object.keys(meta).length; await loadMeta(c.items); if (Object.keys(meta).length !== had) render(); return c; });
  function openCart() {
    if (!cd) return;
    const bar = $('#cdBar'), list = $('#cdList');
    if (!cd.classList.contains('open')) { // open: bar fills and the total counts up from zero, rows stagger in
      bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; void bar.offsetWidth; bar.style.transition = '';
      shownSpent = 0; list.classList.add('in'); setTimeout(() => list.classList.remove('in'), 1400);
      setTimeout(() => cart && reward(cart.total_price, cart.item_count, giftOnly()), 180);
    }
    cd.classList.add('open'); document.body.classList.add('cd-on'); cd.setAttribute('aria-hidden', 'false'); scrim.hidden = false; requestAnimationFrame(() => scrim.classList.add('on')); document.body.style.overflow = 'hidden';
  }
  function closeCart() { cd.classList.remove('open'); document.body.classList.remove('cd-on'); cd.setAttribute('aria-hidden', 'true'); scrim.classList.remove('on'); setTimeout(() => (scrim.hidden = true), 380); document.body.style.overflow = ''; }
  const toast = (msg) => { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 2600); };
  // items: [{ id, quantity, selling_plan? }]
  async function add(items, { upsell } = {}) {
    try { await json(`${LL.routes.add}.js`, { items }); } catch (e) { toast(e.message); return; }
    await refresh();
    if (upsell && upsell.cases && upsell.cases.length) return buyMore(upsell);
    openCart();
  }
  window.LLcart = { add, refresh, open: openCart, close: closeCart };

  /* ---------- "Buy more, save more" pop-up (design F) after a single add ---------- */
  // d: { t, img, p (single price, cents), v (single variant id), w, cases: [{ n, v, p, a }] }
  function buyMore(d) {
    $$('.up-sheet').forEach((x) => x.remove());
    const one = d.p;
    // only sizes that lower the per-bottle price (specials hit the 25% cap early, so 6 and 12 can price the same)
    const os = d.cases.filter((c) => c.a !== false).map((c) => ({ n: c.n, v: c.v, each: Math.round(c.p / c.n), total: c.p, save: one * c.n - c.p }))
      .filter((o, k, a) => o.each < one && (k === 0 || o.each < a[k - 1].each));
    if (!os.length) return openCart();
    const opts = [{ n: 1, each: one, total: one, save: 0 }, ...os];
    const pre = one > 15000 ? 0 : opts.length - 1; // premium bottles start on one, everyday bottles on the best size
    const w = d.w || 'bottle';
    const m = document.createElement('div'); m.className = 'up-sheet qs-wrap';
    m.innerHTML = `<div class="qs" role="dialog" aria-modal="true" aria-label="Buy more, save more">
      <button type="button" class="up-x qs-x" aria-label="Close">×</button>
      <span class="qs-stk" data-qss></span>
      <p class="qs-added">✓ ${esc(d.t)} added</p>
      <p class="qs-h">Buy more, save more.</p>
      <p class="qs-price"><b data-qse></b></p>
      <p class="qs-was" data-qsl></p>
      <div class="qs-seg" role="radiogroup" aria-label="How many" style="--n:${opts.length}">${opts.map((o, k) => `<label class="${k === pre ? 'on' : ''}"><input type="radio" name="qs" value="${k}"${k === pre ? ' checked' : ''}>${o.n}</label>`).join('')}</div>
      <button type="button" class="qs-go" data-qsgo></button>
      <button type="button" class="up-keep qs-keep">Keep 1</button>
    </div>`;
    document.body.appendChild(m);
    const pick = () => opts[Number($('input[name=qs]:checked', m).value)];
    const sync = () => {
      const o = pick();
      $$('.qs-seg label', m).forEach((x) => x.classList.toggle('on', x.contains($('input:checked', m))));
      const stk = $('[data-qss]', m); stk.textContent = `Save ${money(o.save)}`; stk.hidden = o.n === 1;
      $('[data-qse]', m).textContent = money(o.each);
      $('[data-qsl]', m).innerHTML = o.n > 1 ? `down from <s>${money(one)}</s> when you buy ${o.n}` : `Buy ${os[0].n} or more and every ${w} costs less`;
      $('[data-qsgo]', m).textContent = o.n > 1 ? `Make it ${o.n} · ${money(o.total)}` : 'Keep 1 in my cart';
      $('.qs-keep', m).hidden = o.n === 1;
    };
    const shut = () => { m.remove(); openCart(); };
    m.addEventListener('change', sync); sync();
    m.addEventListener('click', async (e) => {
      if (e.target === m || e.target.closest('.up-x,.up-keep')) return shut();
      if (!e.target.closest('[data-qsgo]')) return;
      const o = pick();
      if (o.n > 1) {
        // swap the single just added for the case: add the case, then take one single off
        try {
          await json(`${LL.routes.add}.js`, { items: [{ id: o.v, quantity: 1 }] });
          const line = cart.items.find((it) => it.variant_id === d.v && !it.selling_plan_allocation);
          if (line) await json(`${LL.routes.change}.js`, { id: line.key, quantity: line.quantity - 1 });
          await refresh();
        } catch (err) { toast(err.message); }
      }
      shut();
    });
    requestAnimationFrame(() => m.classList.add('on'));
    $('.qs-go', m).focus();
  }

  // Any [data-add="variantId"] button adds one. Cards carry data-ll (offer data) so a single add offers the case.
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add]');
    if (!b || b.closest('#pdOffer')) return;
    e.preventDefault();
    let d = null; try { d = b.dataset.ll ? JSON.parse(b.dataset.ll) : null; } catch {}
    if (d) d.v = Number(b.dataset.add);
    add([{ id: Number(b.dataset.add), quantity: Number(b.dataset.qty || 1) }], { upsell: d });
  });
  $('#cdList')?.addEventListener('click', async (e) => {
    const t = e.target, li = t.closest('.cx-r'), it = li && cart.items.find((x) => x.key === li.dataset.k); if (!it) return;
    const dt = t.closest('[data-dt]');
    if (dt) { const on = !openDt.has(it.key); if (on) openDt.add(it.key); else openDt.delete(it.key); li.classList.toggle('open-dt', on); dt.setAttribute('aria-expanded', on); dt.firstChild.textContent = on ? 'Hide details' : 'See details'; return; }
    const q = t.closest('[data-q]'), rm = t.closest('[data-rm]'), up = t.closest('[data-up]'), b = q || rm || up; if (!b) return;
    b.disabled = true;
    try {
      if (up) { // swap the bottles for the bundle: add the case, then take the singles (or one smaller case) off
        await json(`${LL.routes.add}.js`, { items: [{ id: Number(up.dataset.up), quantity: 1 }] });
        await json(`${LL.routes.change}.js`, { id: it.key, quantity: Number(up.dataset.left) });
        await refresh();
        const nl = cart.items.find((x) => x.variant_id === Number(up.dataset.up)); if (nl) $(`.cx-r[data-k="${nl.key}"]`, cd)?.classList.add('flash');
        return;
      }
      const qty = rm ? 0 : Math.max(0, it.quantity + Number(q.dataset.q));
      if (!qty) { li.classList.add('gone'); await new Promise((r) => setTimeout(r, 320)); }
      const fold = !qty && isBox(it) ? cart.items.filter((x) => !isBox(x) && (x.properties || {})['For box'] === it.product_title).map((x) => x.key) : []; // a box goes with its add-ons
      cart = fold.length ? await json(`${LL.routes.cart}/update.js`, { updates: Object.fromEntries([it.key, ...fold].map((k) => [k, 0])) })
        : await json(`${LL.routes.change}.js`, { id: it.key, quantity: qty });
    } catch (err) { toast(err.message); }
    render();
  });
  $('#cdClose')?.addEventListener('click', closeCart);
  cd?.addEventListener('click', (e) => { if (e.target.closest('[data-cd-close]')) { e.preventDefault(); closeCart(); } });
  scrim?.addEventListener('click', closeCart);
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && cd?.classList.contains('open')) closeCart(); });
  document.addEventListener('click', (e) => { if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); } });
  refresh();
})();

/* Store reviews: rotating quotes (menu pill card, side panel) + the side tab panel */
(() => {
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-rot]').forEach((box) => {
    const items = [...box.children];
    if (items.length < 2 || calm) return;
    let i = 0, hold = false;
    box.addEventListener('mouseenter', () => (hold = true));
    box.addEventListener('mouseleave', () => (hold = false));
    setInterval(() => {
      if (hold || document.hidden) return;
      items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on');
    }, 5000);
  });

  // side tab panel: open/close
  const panel = document.getElementById('rvPanel');
  if (panel) {
    const veil = document.querySelector('.rv-veil'), tab = document.querySelector('.rv-tab');
    const set = (open) => {
      panel.hidden = veil.hidden = !open;
      tab.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) panel.querySelector('.rvx-x').focus(); else tab.focus();
    };
    document.querySelectorAll('[data-rv-tab]').forEach((b) => b.addEventListener('click', () => set(panel.hidden)));
    document.querySelector('.hd-rv')?.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); set(true); } });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) set(false); });
    // option E: source cards switch the list; sort = newest / highest rated
    const srcs = panel.querySelectorAll('[data-rv-src]'), sort = panel.querySelector('[data-rv-sort]');
    let mode = 'new';
    const order = () => panel.querySelectorAll('[data-rv-list]').forEach((l) => [...l.children]
      .sort((x, y) => mode === 'high' ? y.dataset.r - x.dataset.r || y.dataset.d.localeCompare(x.dataset.d) : y.dataset.d.localeCompare(x.dataset.d))
      .forEach((li) => l.append(li)));
    if (srcs.length > 1) srcs.forEach((b) => b.addEventListener('click', () => {
      srcs.forEach((x) => x.classList.toggle('on', x === b));
      panel.querySelectorAll('[data-rv-list]').forEach((l) => { l.hidden = l.dataset.rvList !== b.dataset.rvSrc; });
      panel.querySelector('[data-rv-showing]').textContent = b.dataset.rvN;
    }));
    if (sort) {
      const opts = [...sort.querySelectorAll('[data-rv-sort-opt]')], sum = sort.querySelector('summary');
      const close = () => { window.LLu.shut(sort); sum.focus(); };
      const pick = (o) => {
        mode = o.dataset.rvSortOpt;
        opts.forEach((x) => x.setAttribute('aria-selected', String(x === o)));
        sort.querySelector('[data-rv-sort-cur]').textContent = o.textContent;
        close(); order();
      };
      sort.addEventListener('click', (e) => { const o = e.target.closest('[data-rv-sort-opt]'); if (o) pick(o); });
      sort.addEventListener('keydown', (e) => {
        const i = opts.indexOf(document.activeElement);
        if (e.key === 'Escape' && sort.open) { e.preventDefault(); e.stopPropagation(); close(); }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault(); sort.open = true;
          const cur = i < 0 ? opts.findIndex((x) => x.getAttribute('aria-selected') === 'true') : i + (e.key === 'ArrowDown' ? 1 : -1);
          opts[(cur + opts.length) % opts.length].focus();
        }
      });
      document.addEventListener('click', (e) => { if (sort.open && !sort.contains(e.target)) window.LLu.shut(sort); });
    }
  }
  // /pages/reviews?write=1 opens Judge.me's store review form once its widget is ready
  if (location.pathname === '/pages/reviews' && new URLSearchParams(location.search).get('write')) {
    let tries = 0;
    const t = setInterval(() => {
      const b = document.querySelector('.jdgm-all-reviews-widget.jdgm--done-setup-widget .jdgm-write-rev-link');
      if (b || ++tries > 80) { clearInterval(t); if (b) { b.click(); b.scrollIntoView({ block: 'center' }); } }
    }, 150);
  }
})();
